<template>
    <v-menu ref="menu"
            v-model="showPicker"
            :close-on-content-click="false"
            :return-value.sync="colorHex"
            transition="scale-transition"
            offset-y>
        <template v-slot:activator="{ on }">
            <v-text-field outlined
                          v-model="colorHex"
                          :label="label"
                          :placeholder="label"
                          readonly
                          v-on="on"
                          :rules="rules"
            >
                <template v-slot:prepend-inner>
                    <v-icon v-if="!colorHex">mdi-palette</v-icon>
                    <div v-else class="color-preview" :style="colorPreviewStyle"></div>
                </template>
            </v-text-field>
        </template>
        <v-card max-width="300px">
            <v-color-picker flat
                            mode="hexa"
                            v-model="pickerValue"></v-color-picker>
            <v-card-actions>
                <v-btn text
                       color="secondary"
                       @click="showPicker = false"
                       class="mr-4">{{$t('cancel')}}
                </v-btn>
                <v-btn text
                       color="primary"
                       :disabled="!pickerValue"
                       @click="$refs.menu.save(pickerValue)">{{$t('ok')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
    import {ref, watch, computed} from '@vue/composition-api';

    export default {
        name: 'ColorPickerInput',
        props: {
            value: String,
            label: String,
            rules: Array,
        },
        setup(props, {emit}) {

            const colorHex = ref(props.value);

            const pickerValue = ref('#FFFFFF');

            const showPicker = ref(false);

            watch(() => props.value, (newVal) => {
                if (newVal) {
                    pickerValue.value = newVal;
                    colorHex.value = newVal;
                }
            });

            watch([colorHex], ([newVal]) => {
                emit('input', newVal);
            });

            const colorPreviewStyle = computed(() => {
                return {
                    width: '1.2rem',
                    height: '1.2rem',
                    'margin-top': '2px',
                    'background-color': colorHex.value,
                }
            });

            return {
                colorHex,
                pickerValue,
                showPicker,
                colorPreviewStyle,
            }
        },
    }
</script>